export default __webpack_public_path__ + "static/media/iconExcel.b0e69cda.jpg";